package br.com.htms.inspeccaocampo.export

/**
 * ZIP sem compressão (method STORE) — compatível com Excel/OOXML em KMP.
 */
object ZipStoreWriter {
    fun write(entries: Map<String, ByteArray>): ByteArray {
        val out = ArrayList<Byte>()
        val central = ArrayList<Byte>()
        var offset = 0
        val records = mutableListOf<Triple<String, Int, Int>>()

        entries.forEach { (name, data) ->
            val nameBytes = name.encodeToByteArray()
            val localOffset = offset
            out += intLe(0x04034b50)
            out += shortLe(20)
            out += shortLe(0)
            out += shortLe(0)
            out += shortLe(0); out += shortLe(0)
            val crc = crc32(data)
            out += intLe(crc)
            out += intLe(data.size)
            out += intLe(data.size)
            out += shortLe(nameBytes.size)
            out += shortLe(0)
            out += nameBytes.toList()
            out += data.toList()
            offset = out.size

            records += Triple(name, localOffset, data.size)
            central += intLe(0x02014b50)
            central += shortLe(20); central += shortLe(20)
            central += shortLe(0); central += shortLe(0)
            central += shortLe(0); central += shortLe(0)
            central += intLe(crc)
            central += intLe(data.size); central += intLe(data.size)
            central += shortLe(nameBytes.size); central += shortLe(0); central += shortLe(0)
            central += shortLe(0); central += shortLe(0); central += intLe(0)
            central += intLe(localOffset)
            central += nameBytes.toList()
        }

        val centralOffset = out.size
        out += central
        out += intLe(0x06054b50)
        out += shortLe(0); out += shortLe(0)
        out += shortLe(records.size); out += shortLe(records.size)
        out += intLe(central.size)
        out += intLe(centralOffset)
        out += shortLe(0)
        return out.toByteArray()
    }

    private fun MutableList<Byte>.plusAssign(bytes: List<Byte>) {
        addAll(bytes)
    }

    private fun shortLe(v: Int): List<Byte> = listOf(
        (v and 0xff).toByte(),
        ((v shr 8) and 0xff).toByte()
    )

    private fun intLe(v: Int): List<Byte> = listOf(
        (v and 0xff).toByte(),
        ((v shr 8) and 0xff).toByte(),
        ((v shr 16) and 0xff).toByte(),
        ((v shr 24) and 0xff).toByte()
    )

    private fun crc32(data: ByteArray): Int {
        var crc = 0xffffffff.toInt()
        for (b in data) {
            crc = crc xor (b.toInt() and 0xff)
            repeat(8) {
                crc = if (crc and 1 != 0) (crc ushr 1) xor 0xedb88320.toInt() else crc ushr 1
            }
        }
        return crc xor 0xffffffff.toInt()
    }
}
